import type {
  TeamSavedModalConfig,
  TeamSavedModalContext,
  TeamSavedPromotion,
} from "./types";

export const promotionEligibility: Record<
  TeamSavedPromotion,
  (context: TeamSavedModalContext) => boolean
> = {
  lastFanStanding: () => true,
  // Challenge promotion is only shown before the last kickoff
  challenge: ({ isBeforeLastKickoff }) => isBeforeLastKickoff,
  // Entries that already have a badge don't need the Adobe promotion
  adobe: ({ entry, adobeEnabled }) => adobeEnabled && !entry.club_badge_src,
  default: ({ entry, adobeEnabled }) =>
    !adobeEnabled || entry.club_badge_src !== null,
};

export const teamSavedModalConfig: TeamSavedModalConfig = {
  // once: top priority eligible modal on the first save of the Gameweek only
  // always: one modal every save, cycling through eligible modals in priority order
  // off: no modals will be shown
  frequency: "once",
  // High to low priority order
  promotionsByPriority: ["challenge", "adobe", "default"],
};
